import React, { PropsWithChildren } from 'react';
import { InfoCard } from '@innovyze/stylovyze';
import { Typography } from '@mui/material';
import { useGlobalization } from '@Translations';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ValuemappingProfileCardProps {}

export const ValuemappingProfileCard: React.FC<ValuemappingProfileCardProps> = (
	props: PropsWithChildren<ValuemappingProfileCardProps>,
) => {
	const { t } = useGlobalization();
	return (
		<InfoCard title={t('Data point correction profile')}>
			<Typography>
				{t(
					// eslint-disable-next-line max-len
					'Automatically correct data points in your sensors or sensor type by applying the below conditions to your data ingestion.',
				)}
			</Typography>
			{props.children}
		</InfoCard>
	);
};

export default ValuemappingProfileCard;
